import axios from 'axios'
const server = process.env.VUE_APP_API_URL || ''
const api = `${server}/api/customer/product`

const getImagesZip = (artist) => {
  return axios.post(api + '/getImagesZip', { artistCodes: [artist.artistCode] }, { responseType: 'blob' })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const fileName = `${artist.name} - Giclee Images.zip`
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.remove()
    })
}
export default {
  getImagesZip
}
